export { MeetingPage as default } from '@/components/enpages/Ir/Stock/Meeting'
